var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconImmune(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18312_7974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2135 46.0116L27.2241 48L24.0001 44.7759L20.776 48L18.7866 46.0116L22.5938 42.2044V38.0625H25.4063V42.2044L29.2135 46.0116Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0479 15.0647L15.0367 13.0761L12.1875 10.2269V4.78125H9.375V9.375H4.78125V12.1875H10.1707L13.0479 15.0647Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93741 25.4062V22.5937H5.7675L1.98872 18.8149L0 20.8037L3.22444 24.0281L0 27.2524L1.98872 29.2412L5.82375 25.4062H9.93741Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2135 1.98844L25.4063 5.79562V9.9375H22.5938V5.79562L18.7866 1.98844L20.776 0L24.0001 3.22406L27.2241 0L29.2135 1.98844Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0761 32.9634L10.2269 35.8125H4.78125V38.625H9.375V43.2188H12.1875V37.8294L15.0648 34.9521L13.0761 32.9634Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9238 32.9634L32.9351 34.9521L35.8123 37.8294V43.2188H38.6248V38.625H43.2186V35.8125H37.7729L34.9238 32.9634Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 20.8037L46.0112 18.8149L42.2324 22.5937H38.0625V25.4062H42.1762L46.0112 29.2412L47.9999 27.2524L44.7755 24.0281L47.9999 20.8037Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9521 15.0647L37.8294 12.1875H43.2188V9.375H38.625V4.78125H35.8125V10.2269L32.9634 13.0761L34.9521 15.0647Z",
    fill: "#26BFA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0019 8.53125C24.0009 8.53125 24.0009 8.53125 24 8.53125C15.4706 8.53125 8.53125 15.4706 8.53125 24C8.53125 32.5294 15.4706 39.4688 24 39.4688H24.0019C32.5303 39.4678 39.4688 32.5284 39.4688 24C39.4688 15.4716 32.5303 8.53219 24.0019 8.53125Z",
    fill: "#57D9AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 16V21.6001H32V25.6001H26V32H22L22 25.6001H16V21.6001H22V16L26 16Z",
    fill: "#19A690"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18312_7974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImmune);
export default __webpack_public_path__ + "static/media/icon-immune.713d9c830488c2509bf8c672ce7f4ede.svg";
export { ForwardRef as ReactComponent };